/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/createErrorClass */
function e(o){let r=o(t=>{Error.call(t),t.stack=new Error().stack});return r.prototype=Object.create(Error.prototype),r.prototype.constructor=r,r}export{e as createErrorClass};
//# sourceMappingURL=createErrorClass.mjs.map